import type { RaspadinhaParticipatingCompany } from '@/types/raspadinha-campaign'
import { createParticipatingCompany } from './participating-companies'

const DEFAULT_COMPANIES_BY_CAMPAIGN: Record<number, string[]> = {
  1: ['11.444.777/0001-61', '12.345.678/0001-95'],
  2: ['00.776.574/0001-56'],
}

export function getDefaultParticipatingCompaniesForCampaign(
  campaignId: number
): RaspadinhaParticipatingCompany[] {
  const cnpjs = DEFAULT_COMPANIES_BY_CAMPAIGN[campaignId] ?? []
  return cnpjs.map((cnpj) => createParticipatingCompany(cnpj))
}
